import { CSSObject } from '@emotion/react'
import { fonts, fontWeights } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

export const postWidth = '375px'
export const postHeight = '667px'

const containerStyles: CSSObject = {
  backgroundColor: colors.n8.base,
  height: postHeight,
  width: postWidth,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

const contentWrapper: CSSObject = {
  position: 'absolute',
  bottom: '111px',
}

const contentStyle: CSSObject = {
  color: colors.white.base,
  fontFamily: fonts.proximaBlack,
  fontSize: '30px',
  fontWeight: fontWeights.boldest,
  paddingTop: '20px',
  textAlign: 'center',
}

const inputWrapperStyle: CSSObject = {
  alignItems: 'flex-end',
  background: 'transparent',
  display: 'flex',
  height: '144px',
  justifyContent: 'center',
  margin: '0 auto',
  position: 'relative',
  width: '345px',
  zIndex: 1000,
  '.kuiper-input-textarea .kuiper-input-container': {
    alignItems: 'flex-end',
    height: '144px',
  },
  '.kuiper-input': {
    alignItems: 'flex-end',
    height: '144px',
    '-webkit-mask-image':
      'linear-gradient(180deg, rgba(0,0,0,0), 10%, rgba(0,0,0,0.5), 20%, rgba(0,0,0,1))',
    '-webkit-mask-repeat': 'no-repeat',
    '-webkit-mask-position': 'top',
  },

  '.kuiper-input.kuiper-filled .kuiper-input-container, .kuiper-input.kuiper-focused .kuiper-input-container, .kuiper-input-container':
    {
      backgroundColor: 'unset',
      color: 'white',
    },
  '.kuiper-input-element::placeholder': {
    color: 'white !important',
  },
  '.kuiper-input-element:focus::placeholder': {
    color: 'rgba(0,0,0,0) !important',
  },
}

const assetStyle: CSSObject = {
  display: 'flex',
  minWidth: '100px',
  overflow: 'hidden',
  width: '100%',
  'img, video': {
    alignContent: 'center',
    display: 'flex',
    width: '375px',
  },
}

const assetBaseStyle: CSSObject = {
  display: 'flex',
  height: '100%',
  maxHeight: '667px',
  minWidth: '100px',
  overflow: 'hidden',
}

const overlayStyles: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  height: postHeight,
  justifyContent: 'space-between',
  left: '55px',
  position: 'absolute',
  width: postWidth,
  zIndex: 99,
}

export const styles = {
  assetBaseStyle,
  assetStyle,
  containerStyles,
  contentStyle,
  contentWrapper,
  inputWrapperStyle,
  overlayStyles,
}
